import styled from 'styled-components';
import { textOverflow } from 'helpers/styles.js';
import reportIcon from 'images/icons/reportIcon.svg';
import downloadIcon from 'images/icons/downloadIcon.svg';

export const KeywordsContainer = styled.div`
  ${textOverflow};
`;

export const TitleText = styled.div`
  background: url(${reportIcon}) 12px center no-repeat;
  color: ${({ theme }) => theme.colors.palette[7]};
  padding-left: 42px;
  width: 90%;
  ${textOverflow};
`;

export const SubtitleText = styled.div`
  color: #babfcc;
  padding-left: 42px;
  width: 90%;
  ${textOverflow};
  font-size: 12px;
`;

export const ReportLink = styled.div`
  color: ${({ theme }) => theme.colors.palette[7]};
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 2px;
`;

export const DownloadLink = styled.div`
  background: url(${downloadIcon}) center 0px no-repeat;
  height: 20px;
`;
